import {FAQ, Section} from '@primer/react-brand'
import {renderWithNoMarks} from '../../../utils'
import type {OutroSectionProps} from './types'

export const OutroSection = ({outroFaqs, outroFaqsHeading}: OutroSectionProps) => {
  const groupsWithFaqs = outroFaqs?.filter(group =>
    group.fields.faqs.some(faq => faq.fields.question && faq.fields.answer),
  )

  if (!groupsWithFaqs?.length) return null

  return (
    <Section>
      {outroFaqsHeading && <FAQ.Heading>{renderWithNoMarks(outroFaqsHeading)}</FAQ.Heading>}
      {groupsWithFaqs.map(group => {
        const completeFaqs = group.fields.faqs.filter(faq => faq.fields.question && faq.fields.answer)

        return (
          <FAQ key={group.sys.id}>
            {group.fields.heading && <FAQ.Heading>{group.fields.heading}</FAQ.Heading>}
            {completeFaqs.map(faq => (
              <FAQ.Item key={faq.sys.id}>
                <FAQ.Question>{faq.fields.question}</FAQ.Question>
                <FAQ.Answer>{renderWithNoMarks(faq.fields.answer)}</FAQ.Answer>
              </FAQ.Item>
            ))}
          </FAQ>
        )
      })}
    </Section>
  )
}
